
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impress",
      function () {
        return require("private-next-pages/impress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impress"])
      });
    }
  